import React, { useEffect, useState } from 'react';
import './MyDashboards.css';
import { useDispatch, useSelector } from 'react-redux';
import { getMyDashboards, sendDashboardHit } from 'redux/thunks/dashboard';
import { addFavoriteDashboard, removeFavoriteDashboard } from 'redux/thunks/user';
import { useHistory } from 'react-router';
import CircularProgress from '@material-ui/core/CircularProgress';
import AppLoader from 'components/Loader';
import PropTypes from 'prop-types';
import {
    Button,
    TableContainer,
    Table,
    TableBody,
    TableCell,
    TableRow,
    Tooltip,
    Paper,
    TableHead,
    withStyles,
    Tabs,
    Tab,
    Box,
    Typography,
} from '@material-ui/core';
import AddDashboardModal from 'components/AddDashboardModal';
import AddIcon from '@material-ui/icons/Add';
import PersonIcon from '@material-ui/icons/PersonOutline';
import PeopleIcon from '@material-ui/icons/PeopleOutline';
import FavoriteBorderOutlinedIcon from '@material-ui/icons/FavoriteBorderOutlined';
import FavoriteIcon from '@material-ui/icons/Favorite';

const MyDashboards = () => {
    const dispatch = useDispatch();
    const dashboard = useSelector((state) => state.dashboard);
    const email = useSelector((state) => state.user.email);
    const userName = useSelector((state) => state.user.userName);
    const authenticated = useSelector((state) => state.user.authenticated);
    const isMobile = useSelector((state) => state.site.showMobile);
    const favoriteDashboards = useSelector((state) => state.user.favoriteUserDashboards);
    const removingFavorite = useSelector((state) => state.user.removingFavorite);
    const favoriteDashboardsLoading = useSelector((state) => state.user.favoriteDashboardsLoading);
    const history = useHistory();
    const [show, setShow] = useState(false);
    const [favdashs, setFavdashs] = useState(dashboard.dashboards);
    const [tabValue, setTabValue] = React.useState(0);

    const setFavorite = (index, val, dashboard) => {
        let dashs = [...dashboard];
        dashs[index].favorite = val;
        setFavdashs(dashs);
    };

    const handleChangeTab = (event, newValue) => {
        setTabValue(newValue);
    };

    const openDashboard = (dashboard) => {
        dispatch(sendDashboardHit({
            siteId: dashboard.siteId, 
            dashboardId: dashboard.dashboardId, 
            history
        }));
    }    

    const handleUpdateFavoriteDashboard = (index, isFavorite) => {
        if (isFavorite) {
            //need to make correct favorite dashboad obj
            let dashboardToFav = dashboard.dashboards[index];
            delete dashboardToFav.info;
            delete dashboardToFav.links;
            delete dashboardToFav.favorites;
            dispatch(addFavoriteDashboard(dashboardToFav)).then(() => {
                const favDashboardId = dashboard.dashboards[index].dashboardId;
                if (favoriteDashboards.filter((e) => e.dashboardId === favDashboardId).length > 0) {
                    setFavorite(index, true, dashboard.dashboards);
                }
            });
        } else {
            dispatch(removeFavoriteDashboard(dashboard.dashboards[index].dashboardId)).then(() => {
                const unFavDashboardId = dashboard.dashboards[index].dashboardId;
                if (favoriteDashboards.filter((e) => e.dashboardId === unFavDashboardId).length === 0) {
                    setFavorite(index, false, dashboard.dashboards);
                }
            });
        }
    };

    //always only removing favorites from favorite tab so no cases needed
    const handleUpdateFavoriteInFavoriteTab = (index) => {
        const dashboardIdToRemove = favoriteDashboards[index].dashboardId;
        dispatch(removeFavoriteDashboard(dashboardIdToRemove)).then(() => {
            dashboard.dashboards.filter((e, i) => {
                if (e.dashboardId === dashboardIdToRemove) {
                    setFavorite(i, false, dashboard.dashboards);
                }
            });
        });
    };

    useEffect(() => {
        if (authenticated) {
            dispatch(getMyDashboards());
        }
    }, [dispatch, authenticated]);

    //on load mark favorited dashboards that are under my dashboards
    useEffect(() => {
        if (dashboard.dashboards.length > 0 && !favoriteDashboardsLoading) {
            for (let x = 0; x < favoriteDashboards.length; x++) {
                setFavorite(x, true, favoriteDashboards);
                for (let y = 0; y < dashboard.dashboards.length; y++) {
                    if (dashboard.dashboards[y].dashboardId === favoriteDashboards[x].dashboardId) {
                        setFavorite(y, true, dashboard.dashboards);
                        break;
                    }
                }
            }
        }
    }, [dispatch, dashboard, favoriteDashboards, favoriteDashboardsLoading]);

    const StyledTableCell = withStyles((theme) => ({
        head: {
            backgroundColor: theme.palette.common.black,
            color: theme.palette.common.white,
        },
        body: {
            fontSize: 14,
        },
    }))(TableCell);

    const StyledTableRow = withStyles((theme) => ({
        root: {
            '&:nth-of-type(odd)': {
                backgroundColor: theme.palette.action.hover,
            },
        },
    }))(TableRow);

    function TabPanel(props) {
        const { children, value, index, ...other } = props;

        return (
            <div role='tabpanel' hidden={value !== index} id={`simple-tabpanel-${index}`} aria-labelledby={`simple-tab-${index}`} {...other}>
                {value === index && (
                    <Box p={3}>
                        <Typography component='div'>{children}</Typography>
                    </Box>
                )}
            </div>
        );
    }

    TabPanel.propTypes = {
        children: PropTypes.node,
        index: PropTypes.any.isRequired,
        value: PropTypes.any.isRequired,
    };

    function a11yProps(index) {
        return {
            id: `simple-tab-${index}`,
            'aria-controls': `simple-tabpanel-${index}`,
        };
    }

    return (
        <>
            <div className='my-dashboard'>
                {/* Added Material-ui Tabs feature by removing static one. Added Favorite tab */}
                <Tabs value={tabValue} onChange={handleChangeTab} aria-label='simple tabs example' indicatorColor='primary' textColor='primary' className='tab'>
                    <Tab label='My Dashboards' {...a11yProps(0)} />
                    <Tab label='Favorites' {...a11yProps(1)} />
                </Tabs>
                <TabPanel value={tabValue} index={0}>
                    <Button color='primary' size='large' variant='contained' startIcon={<AddIcon />} onClick={() => setShow(true)}>
                        Add New Dashboard
                    </Button>
                    {dashboard.gettingMyDashboards && (
                        <div className='my-dashboard__loader'>
                            <CircularProgress />
                        </div>
                    )}

                    {!dashboard.gettingMyDashboards && dashboard.dashboards && dashboard.dashboards.length > 0 && (
                        <div className='my-dashboard__table'>
                            <TableContainer component={Paper}>
                                <Table className='dashboards-table' aria-label='simple table'>
                                    <TableHead>
                                        {isMobile ? (
                                            <StyledTableRow>
                                                <StyledTableCell>Dashboards</StyledTableCell>
                                            </StyledTableRow>
                                        ) : (
                                            <StyledTableRow>
                                                <StyledTableCell align='left'>Favorite</StyledTableCell>
                                                <StyledTableCell>Dashboard Name</StyledTableCell>
                                                <StyledTableCell style={{ paddingLeft: '0px' }}>Owner</StyledTableCell>
                                                <StyledTableCell>Site</StyledTableCell>
                                                <StyledTableCell align='right'>Hits</StyledTableCell>
                                            </StyledTableRow>
                                        )}
                                    </TableHead>
                                    <TableBody>
                                        {dashboard.dashboards.length < 1 ? (
                                            <StyledTableRow>
                                                <StyledTableCell className='temp-cell' colSpan='4'>
                                                    {dashboard.gettingDashboardsForSite ? (
                                                        <AppLoader containerStyle={{ margin: '30px 0px' }} />
                                                    ) : (
                                                        <div className='temp-cell'>No Dashboards Found</div>
                                                    )}
                                                </StyledTableCell>
                                            </StyledTableRow>
                                        ) : (
                                            <>
                                                {dashboard.gettingDashboardsForSite ? (
                                                    <StyledTableRow>
                                                        <StyledTableCell className='temp-cell' colSpan='4'>
                                                            <AppLoader containerStyle={{ margin: '30px 0px' }} />
                                                        </StyledTableCell>
                                                    </StyledTableRow>
                                                ) : (
                                                    dashboard.dashboards.map((dashboard, key) => {
                                                        return isMobile ? (
                                                            <StyledTableRow
                                                                key={key}
                                                                onClick={() => openDashboard(dashboard)}
                                                            >
                                                                <StyledTableCell>
                                                                    <h3>
                                                                        {dashboard.name || ''}
                                                                        <span>
                                                                            {dashboard.favorite ? (
                                                                                <FavoriteIcon
                                                                                    color='secondary'
                                                                                    className='favIconMobile'
                                                                                    ref={(ref) => {
                                                                                        if (!ref) return;
                                                                                        ref.onclick = (e) => {
                                                                                            e.stopPropagation();
                                                                                            handleUpdateFavoriteDashboard(key, !dashboard.favorite);
                                                                                        };
                                                                                    }}
                                                                                />
                                                                            ) : (
                                                                                <FavoriteBorderOutlinedIcon
                                                                                    className='favIconMobile'
                                                                                    ref={(ref) => {
                                                                                        if (!ref) return;
                                                                                        ref.onclick = (e) => {
                                                                                            e.stopPropagation();
                                                                                            handleUpdateFavoriteDashboard(key, !dashboard.favorite);
                                                                                        };
                                                                                    }}
                                                                                />
                                                                            )}
                                                                        </span>
                                                                    </h3>
                                                                    <div style={{ display: 'flex', alignItems: 'flex-end' }}>
                                                                        <span style={{ paddingRight: '5px' }}>Owner: </span>
                                                                        {dashboard.owner === userName ? (
                                                                            <Tooltip title='Owner'>
                                                                                <PersonIcon></PersonIcon>
                                                                            </Tooltip>
                                                                        ) : (
                                                                            <></>
                                                                        )}
                                                                        {dashboard.contributors.map((contributor) => {
                                                                            if (contributor.email === email) {
                                                                                return (
                                                                                    <Tooltip key={email} title='Contributor'>
                                                                                        <PeopleIcon></PeopleIcon>
                                                                                    </Tooltip>
                                                                                );
                                                                            } else {
                                                                                return null;
                                                                            }
                                                                        })}
                                                                        <span style={{ paddingLeft: '5px' }}>{dashboard.owner || ''}</span>
                                                                    </div>
                                                                    <div>Site: {dashboard.siteId || ''}</div>
                                                                    <div>Hits: {dashboard.hits || 0}</div>
                                                                </StyledTableCell>
                                                            </StyledTableRow>
                                                        ) : (
                                                            <StyledTableRow
                                                                key={key}
                                                                onClick={() => openDashboard(dashboard)}
                                                            >
                                                                <StyledTableCell align='left'>
                                                                    {dashboard.favorite ? (
                                                                        <FavoriteIcon
                                                                            color='secondary'
                                                                            className='favIcon'
                                                                            ref={(ref) => {
                                                                                if (!ref) return;
                                                                                ref.onclick = (e) => {
                                                                                    e.stopPropagation();
                                                                                    handleUpdateFavoriteDashboard(key, !dashboard.favorite);
                                                                                };
                                                                            }}
                                                                        />
                                                                    ) : (
                                                                        <FavoriteBorderOutlinedIcon
                                                                            className='favIcon'
                                                                            ref={(ref) => {
                                                                                if (!ref) return;
                                                                                ref.onclick = (e) => {
                                                                                    e.stopPropagation();
                                                                                    handleUpdateFavoriteDashboard(key, !dashboard.favorite);
                                                                                };
                                                                            }}
                                                                        />
                                                                    )}
                                                                </StyledTableCell>
                                                                <StyledTableCell>
                                                                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                                                        {dashboard.name || ''}
                                                                        {dashboard.owner === userName ? (
                                                                            <Tooltip title='Owner'>
                                                                                <PersonIcon></PersonIcon>
                                                                            </Tooltip>
                                                                        ) : (
                                                                            <></>
                                                                        )}
                                                                        {dashboard.contributors.map((contributor) => {
                                                                            if (contributor.email === email) {
                                                                                return (
                                                                                    <Tooltip key={email} title='Contributor'>
                                                                                        <PeopleIcon></PeopleIcon>
                                                                                    </Tooltip>
                                                                                );
                                                                            } else {
                                                                                return null;
                                                                            }
                                                                        })}
                                                                    </div>
                                                                </StyledTableCell>
                                                                <StyledTableCell style={{ paddingLeft: '0px' }}>{dashboard.owner || ''}</StyledTableCell>
                                                                <StyledTableCell>{dashboard.siteId || ''}</StyledTableCell>
                                                                <StyledTableCell align='right'>{dashboard.hits || 0}</StyledTableCell>
                                                            </StyledTableRow>
                                                        );
                                                    })
                                                )}
                                            </>
                                        )}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </div>
                    )}
                    {!dashboard.gettingMyDashboards && dashboard.dashboards && dashboard.dashboards.length === 0 && (
                        <div className='my_dashboards__no-table'>There are no dashboards at this time</div>
                    )}
                </TabPanel>
                <TabPanel value={tabValue} index={1}>
                    {dashboard.gettingMyDashboards && (
                        <div className='my-dashboard__loader'>
                            <CircularProgress />
                        </div>
                    )}

                    {!dashboard.favoriteDashboardsLoading && favoriteDashboards && favoriteDashboards.length > 0 && (
                        <div className='my-dashboard__table'>
                            <TableContainer component={Paper}>
                                <Table className='dashboards-table' aria-label='simple table'>
                                    <TableHead>
                                        {isMobile ? (
                                            <StyledTableRow>
                                                <StyledTableCell>Dashboards</StyledTableCell>
                                            </StyledTableRow>
                                        ) : (
                                            <StyledTableRow>
                                                <StyledTableCell align='left'>Favorite</StyledTableCell>
                                                <StyledTableCell>Dashboard Name</StyledTableCell>
                                                <StyledTableCell style={{ paddingLeft: '0px' }}>Owner</StyledTableCell>
                                                <StyledTableCell>Site</StyledTableCell>
                                                <StyledTableCell align='right'>Hits</StyledTableCell>
                                            </StyledTableRow>
                                        )}
                                    </TableHead>
                                    <TableBody>
                                        {favoriteDashboards.length < 1 ? (
                                            <StyledTableRow>
                                                <StyledTableCell className='temp-cell' colSpan='4'>
                                                    {dashboard.gettingDashboardsForSite ? (
                                                        <AppLoader containerStyle={{ margin: '30px 0px' }} />
                                                    ) : (
                                                        <div className='temp-cell'>No Favorite Dashboards Found</div>
                                                    )}
                                                </StyledTableCell>
                                            </StyledTableRow>
                                        ) : (
                                            <>
                                                {favoriteDashboardsLoading ? (
                                                    <StyledTableRow>
                                                        <StyledTableCell className='temp-cell' colSpan='4'>
                                                            <AppLoader containerStyle={{ margin: '30px 0px' }} />
                                                        </StyledTableCell>
                                                    </StyledTableRow>
                                                ) : (
                                                    favoriteDashboards.map((dashboard, key) => {
                                                        return isMobile ? (
                                                            <StyledTableRow
                                                                key={key}
                                                                onClick={() => openDashboard(dashboard)}
                                                            >
                                                                <StyledTableCell>
                                                                    <h3>
                                                                        {dashboard.name || ''}
                                                                        <span>
                                                                            {dashboard.favorite ? (
                                                                                <FavoriteIcon
                                                                                    color='secondary'
                                                                                    className='favIconMobile'
                                                                                    ref={(ref) => {
                                                                                        if (!ref) return;
                                                                                        ref.onclick = (e) => {
                                                                                            e.stopPropagation();
                                                                                            handleUpdateFavoriteInFavoriteTab(key, !dashboard.favorite);
                                                                                        };
                                                                                    }}
                                                                                />
                                                                            ) : (
                                                                                <FavoriteBorderOutlinedIcon
                                                                                    className='favIconMobile'
                                                                                    ref={(ref) => {
                                                                                        if (!ref) return;
                                                                                        ref.onclick = (e) => {
                                                                                            e.stopPropagation();
                                                                                            handleUpdateFavoriteInFavoriteTab(key, !dashboard.favorite);
                                                                                        };
                                                                                    }}
                                                                                />
                                                                            )}
                                                                        </span>
                                                                    </h3>
                                                                    <div style={{ display: 'flex', alignItems: 'flex-end' }}>
                                                                        <span style={{ paddingRight: '5px' }}>Owner: </span>
                                                                        {dashboard.owner === userName ? (
                                                                            <Tooltip title='Owner'>
                                                                                <PersonIcon></PersonIcon>
                                                                            </Tooltip>
                                                                        ) : (
                                                                            <></>
                                                                        )}
                                                                        {dashboard.contributors.map((contributor) => {
                                                                            if (contributor.email === email) {
                                                                                return (
                                                                                    <Tooltip key={email} title='Contributor'>
                                                                                        <PeopleIcon></PeopleIcon>
                                                                                    </Tooltip>
                                                                                );
                                                                            } else {
                                                                                return null;
                                                                            }
                                                                        })}
                                                                        <span style={{ paddingLeft: '5px' }}>{dashboard.owner || ''}</span>
                                                                    </div>
                                                                    <div>Site: {dashboard.siteId || ''}</div>
                                                                    <div>Hits: {dashboard.hits || 0}</div>
                                                                </StyledTableCell>
                                                            </StyledTableRow>
                                                        ) : (
                                                            <StyledTableRow
                                                                key={key}
                                                                onClick={() => openDashboard(dashboard)}
                                                            >
                                                                <StyledTableCell align='left'>
                                                                    {dashboard.favorite ? (
                                                                        <FavoriteIcon
                                                                            color='secondary'
                                                                            className='favIcon'
                                                                            ref={(ref) => {
                                                                                if (!ref) return;
                                                                                ref.onclick = (e) => {
                                                                                    e.stopPropagation();
                                                                                    handleUpdateFavoriteInFavoriteTab(key, !dashboard.favorite);
                                                                                };
                                                                            }}
                                                                        />
                                                                    ) : (
                                                                        <FavoriteBorderOutlinedIcon
                                                                            className='favIcon'
                                                                            ref={(ref) => {
                                                                                if (!ref) return;
                                                                                ref.onclick = (e) => {
                                                                                    e.stopPropagation();
                                                                                    handleUpdateFavoriteInFavoriteTab(key, !dashboard.favorite);
                                                                                };
                                                                            }}
                                                                        />
                                                                    )}
                                                                </StyledTableCell>
                                                                <StyledTableCell>
                                                                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                                                        {dashboard.name || ''}
                                                                        {dashboard.owner === userName ? (
                                                                            <Tooltip title='Owner'>
                                                                                <PersonIcon></PersonIcon>
                                                                            </Tooltip>
                                                                        ) : (
                                                                            <></>
                                                                        )}
                                                                        {dashboard.contributors.map((contributor) => {
                                                                            if (contributor.email === email) {
                                                                                return (
                                                                                    <Tooltip key={email} title='Contributor'>
                                                                                        <PeopleIcon></PeopleIcon>
                                                                                    </Tooltip>
                                                                                );
                                                                            } else {
                                                                                return null;
                                                                            }
                                                                        })}
                                                                    </div>
                                                                </StyledTableCell>
                                                                <StyledTableCell style={{ paddingLeft: '0px' }}>{dashboard.owner || ''}</StyledTableCell>
                                                                <StyledTableCell>{dashboard.siteId || ''}</StyledTableCell>
                                                                <StyledTableCell align='right'>{dashboard.hits || 0}</StyledTableCell>
                                                            </StyledTableRow>
                                                        );
                                                    })
                                                )}
                                            </>
                                        )}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </div>
                    )}
                    {!dashboard.gettingMyDashboards && dashboard.dashboards && dashboard.dashboards.length === 0 && (
                        <div className='my_dashboards__no-table'>There are no dashboards at this time</div>
                    )}
                </TabPanel>
            </div>

            {show && <AddDashboardModal show={show} setShow={setShow} />}
        </>
    );
};

export default MyDashboards;
